/* eslint-disable react/react-in-jsx-scope */
// Import Swiper React components
import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "../../../assets/styles/SearchPage/Utils/_swiper.sass";
import { BASE_URL } from "../../../Helpers";

// Import missing components
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Import missing images - using correct paths based on other components
import levelPlatinium from "../../../assets/static/housing-promotions/bandas-plata-borde.png";
import hotSale from "../../../assets/static/hot_sale/alohar-hot-sale.png";

const CardSlider = (props) => {
  const [imageLoadingStates, setImageLoadingStates] = useState({});
  const maxAmount = 4;
  
  const photos = props.housingMedia.sort((a, b) => {
    if (a.cover > b.cover) {
      return -1;
    }
    if (a.cover < b.cover) {
      return 1;
    }
    return 0;
  });
  const textStyle = props.map === true ? "InfoWindow" : "SmallCard";

  const handleImageLoad = (photoId) => {
    setImageLoadingStates((prev) => ({
      ...prev,
      [photoId]: false,
    }));
  };

  const handleImageError = (photoId) => {
    setImageLoadingStates((prev) => ({
      ...prev,
      [photoId]: false,
    }));
  };

  const slides = photos.slice(0, maxAmount).map((photo) => {
    const img =
      photo.media !== null
        ? `${BASE_URL}/${photo.media.replace("public/", "")}`
        : "https://upload.wikimedia.org/wikipedia/commons/0/0a/No-image-available.png";

    // Inicializar como loading si no existe en el estado
    const isLoading = imageLoadingStates[photo.id] !== false;

    return (
      <SwiperSlide key={photo.id}>
        {isLoading && (
          <div className="CardSlider__skeleton">
            <Skeleton height="100%" />
          </div>
        )}
        <img
          className={`${textStyle}__imgcontainer__img ${
            isLoading ? "loading" : "loaded"
          }`}
          src={img}
          alt="Card"
          onLoad={() => handleImageLoad(photo.id)}
          onError={() => handleImageError(photo.id)}
        />
      </SwiperSlide>
    );
  });
  return (
    <Swiper
      spaceBetween={0}
      slidesPerView={1}
      navigation={!props.disabledSlider}
      pagination={{ clickable: true }}
      modules={[Navigation, Pagination, A11y]}
      className={`relative  overflow-hidden ${textStyle}__imgcontainer`}
    >
      {props.valideighlight &&
        props.housingPromotions?.priorityLevel.priority === 2 && (
          <img
            src={levelPlatinium}
            alt="level platinum"
            className="absolute top-0 left-0 z-50 w-[45%]"
          />
        )}
      {/* {props.level === 1 && (
        <img
          src={levelGold}
          alt="Hot sale"
          className="absolute z-50 left-1 top-1"
        />
      )}  */}
      {props.hotSale && [0, 2].includes(props.status) && (
        <img
          src={hotSale}
          alt="Hot sale"
          className="absolute right-[5%] z-50 w-10 top-0"
        />
      )}
      {slides}
    </Swiper>
  );
};

export default CardSlider;
